import { configContextState, setConfigStateById } from '@/contexts/ConfigContext/ConfigContext';

export const updateConfigContext = (setState: setConfigStateById) => (updateObject: Partial<configContextState>) => {
  setState('UPDATE', (s) => {
    return {
      ...s,
      ...updateObject,
    };
  });
};
